<template>
  <div>
    <h1 style="color:#00467f;text-align:left;margin-top:5px"><strong>BONUS EDILIZIA</strong></h1>
    <hr>
    <div class="row" style="margin-bottom:20px;margin-left:5px">
        <div class="col rectangle row-color" @click="caricaPagina('3')">
            <h1 class="box-text">BONUS 50%</h1>
        </div>
        <div class="col rectangle row-color" @click="caricaPagina('2')">
            <h1 class="box-text">BONUS 90%</h1>
        </div>
        <div class="col rectangle row-color" @click="caricaPagina('1')">
            <h1 class="box-text">BONUS 110%</h1>
        </div>
    </div>
    <hr>
    <card v-if="show" style="margin-top:20px">
        <form>
          <div class="row" style="margin-top:20px;margin-bottom:15px;margin-right:40px;margin-left:40px">
            <div class="col">
              <label for="data" style="font-weight:bold;margin-bottom:10px">Data<span style="color:#ff0000">*</span></label>
              <input type="date" class="form-control" id="data" v-model="data" placeholder="data">
            </div>
            <div class="col">
              <label for="id_tipologia" style="font-weight:bold;margin-bottom:10px">Id tipologia<span style="color:#ff0000">*</span></label>
                <select id="id_tipologia" v-model="id_tipologia" class="form-control">
                  <option value="3">Bonus 50%</option>
                  <option value="2">Bonus 90%</option>
                  <option value="1">Bonus 110%</option>
                </select>
            </div>
          </div>
          <div class="row" style="margin-top:20px;margin-bottom:15px;margin-right:40px;margin-left:40px">
            <div class="col align-self-center">
              <label for="denominazione" style="font-weight:bold;margin-bottom:10px">Denominazione<span style="color:#ff0000">*</span></label>
              <input type="text" class="form-control" id="denominazione" v-model="denominazione" placeholder="denominazione">
            </div>
          </div>
          <div class="row" style="margin-bottom:15px;margin-right:40px;margin-left:40px">
            <div class="col align-self-center">
              <label for="codice_fiscale" style="font-weight:bold;margin-bottom:10px">Codice Fiscale<span style="color:#ff0000">*</span></label>
              <input type="text" class="form-control" id="codice_fiscale" v-model="codice_fiscale" placeholder="codice_fiscale">
            </div>
          </div>
          <!-- <div class="row"> -->
          <router-link to="/asseverazioni" class="btn float-center" style="margin-right:50px;background:#00467f">Indietro</router-link>
          <button type="button" class="btn float-center" style="background:#00467f;" v-on:click="salvaValori()">Salva</button>
          <!-- </div> -->
        </form>
        <!-- <div class="row">
            <div class="col" style="text-align:center">
              <h3 style="text-align:center;margin-top:20px">BONUS {{bonus}} %</h3>
              <p style="margin-top:10px;font-size:24px">ANTIRICICLAGGIO</p>
              <button class="btn">Premi qui per una richiesta</button>
              <p style="margin-top:10px;font-size:24px">CARICA DOCUMENTO 1</p>
              <button class="btn">Carica doc 1</button>
              <p style="margin-top:10px;font-size:24px">CARICA DOCUEMNTO 2</p>
              <button class="btn">Carica doc 2</button>
            </div>
        </div> -->
    </card>
    
  </div>
</template>
<script>
import Card from '../../components/Cards/Card.vue';
import Services from '@/services/Services';
import AsseverazioniServices from '@/services/AsseverazioniServices';
import axios from 'axios';

export default {
  components: {
    Card  
  },
  /**
   * Chart data used to render stats, charts. Should be replaced with server data
   */
  data() {
    return {
        show50: false,
        show90: false,
        show110: false,
        show: false,
        bonus: null,

        codice_fiscale: null,
        denominazione:null,
        dati: [],

        id_tipologia: null,
        data: null,
        denominazione: null,
        codice_fiscale: null,

        access_token: null,
        token_response: [],
        user_livello: null,
        urlRichieste: 'https://sviluppoallergeni.confcom.it/'
    };
  },
  methods: {
    caricaPagina: function(value) {
        this.show = true;
        this.id_tipologia = value;
        console.log(`id_tipologia =${this.id_tipologia}`);
        // this.bonus = value;
        // if (value == '50') {
        //     this.show50 = true;
        //     this.show90 = false;
        //     this.show110 = false;
        //     console.log(`show50: ${this.show50}, show90: ${this.show90}, show110: ${this.show110}`);
        // }
        // else if (value == '90') {
        //     this.show90 = true;
        //     this.show50 = false;
        //     this.show110 = false;
        //     console.log(`show50: ${this.show50}, show90: ${this.show90}, show110: ${this.show110}`);
        // }
        // else {
        //     this.show110 = true;
        //     this.show50 = false;
        //     this.show90 = false;
        //     console.log(`show50: ${this.show50}, show90: ${this.show90}, show110: ${this.show110}`);
        // }
    },

    salvaValori: async function() {
      /* id_tipologia: null, data: null, denominazione: null, codice_fiscale: null, */
      let dati = dati.push({ ID_TIPOLOGIA: this.id_tipologia, DATA: this.data, DENOMINAZIONE_DITTA: this.denominazione, CF: this.codice_fiscale });
      let risposta =[];
      let errore = 0;
      await AsseverazioniServices.createAsseverazione(dati)
      .then(response => { risposta = response.data})
      .catch( async function (error) {
        // handle error
        if(error.response.status == 401){
            errore = error.response.status;
            console.log(`errore = ${errore}`);
        }
      })
      if (errore == 401) {
        let value = await Services.refreshTokenFunction();//await this.refreshToken();
        if (value) { await this.salvaValori(); }
      }
      this.$router.push({
        path: '/asseverazioni'
      })
    },

    main() {
       
    },
    
  },
  mounted() {
      this.main();
    }
};
</script>
<style scoped>
    label {
        font-size: 16px;
    } 
    h3 {
        color:black;
        text-align: left;
    }
  .rectangle {
    height: 180px;
    /* width: 10px; */
    display: inline;
    margin-right: 70px;
    margin-left: 70px;
    margin-top: 20px;
    float: left;
    border-style: solid;
    border-color: #00467f;
    border-width: 5px;
    line-height: 200px;
    cursor: pointer;
  }

  .box-text {
    display: inline-block;
    text-align: center;
    line-height: normal;
    vertical-align: middle;
    font-weight: bold;
    color: #00467f;
  }
</style>
